export default __webpack_public_path__ + "static/media/in_body_a2_by_cvrtis-da7k69a.ade8bd3b.png";